module.exports = __webpack_public_path__ + "img/user-phone.481cd3a.svg";